import { AxiosResponse } from 'axios';

import { CreateThreePointRequestType, FetchThreePointsRequestType } from './types';

import { CommonResponseType } from 'api/authApi';
import { GeneralResponseType } from 'common';
import { authServiceClient } from 'config';
import { ThreePointsType } from 'state';

export const fetchThreePointsRequest = (params?: FetchThreePointsRequestType) => {
  return authServiceClient.get<
    GeneralResponseType<ThreePointsType>,
    AxiosResponse<GeneralResponseType<ThreePointsType>>,
    FetchThreePointsRequestType
  >(`/three-points`, { params });
};

export const createThreePointRequest = (data: CreateThreePointRequestType) => {
  return authServiceClient.post<
    ThreePointsType,
    AxiosResponse<ThreePointsType>,
    CreateThreePointRequestType
  >(`/three-points`, data);
};

export const deleteThreePointRequest = (id: string) => {
  return authServiceClient.delete<CommonResponseType, AxiosResponse<CommonResponseType>>(
    `/three-points/${id}`,
  );
};
